<template>
  <article class="metric-card">
    <div class="metric-content">
      <div class="metric-number">{{ formatValue(value) }}</div>
      <div class="metric-label">
        <p class="metric-title">{{ title }}</p>
        <p v-if="subTitle" class="metric-subtitle">{{ subTitle }}</p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'SimpleIntegerCard',
  props: {
    title: { type: String, default: "" },
    subTitle: { type: String, default: "" },
    dataFetcher: { type: Function, default: null },
    integerValue: { type: Number, default: null }
  },
  data() {
    return { value: this.integerValue }
  },
  watch: {
    integerValue(newVal) {
      this.value = newVal;
    }
  },
  async mounted() {
    try {
      if (this.dataFetcher != null) {
        this.value = await this.dataFetcher();
      }
    } catch (error) {
      console.error(`Error fetching data for ${this.title}`, error);
    }

    if (this.integerValue != null) {
      this.value = this.integerValue;
    }
  },
  methods: {
    formatValue(v) {
      if (v == null) return '—';
      if (typeof v === 'number') return v.toLocaleString();
      return v;
    }
  }
}
</script>

<style scoped>
.metric-card {
  background: var(--duallo-card-gradient);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  color: #fff;
  height: 100%;
  width: 100%;
  padding: 20px 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.metric-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
}

.metric-number {
  font-size: clamp(2rem, 5vw, 2.75rem);
  font-weight: 700;
  color: var(--duallo-accent-muted);
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}

.metric-label {
  text-align: center;
}

.metric-title {
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
  color: #cfd8dc;
}

.metric-subtitle {
  font-size: 0.8rem;
  color: #8aa0aa;
  margin: 2px 0 0;
}

@media (max-width: 600px) {
  .metric-card {
    padding: 18px 16px;
  }

  .metric-title {
    font-size: 0.9rem;
  }
}
</style>
